import ConsentModal from 'conversations-visitor-experience-components/visitor-widget/ConsentModal';
import ConsentPromptV2 from 'conversations-visitor-experience-components/visitor-widget/components/ConsentPromptV2';
import ConsentPrompt from 'conversations-visitor-experience-components/visitor-widget/ConsentPrompt';
import { CHAT_THREAD, SPOTLIGHT } from 'conversations-visitor-experience-components/visitor-widget/constants/consentPromptVariants';
import useCookieConsentPrompt from '../../gdpr/hooks/useCookieConsentPrompt';
import ConsentPromptWrapper from './ConsentPromptWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const CookieConsentPrompt = () => {
  const {
    isAIChatBot,
    isSpotlight,
    widgetColoring,
    isExitIntentPrompt,
    pageLoadMessage,
    exitIntentHeaderMessage,
    exitIntentMessage,
    handleConsentToCookies,
    handleDeclineCookies
  } = useCookieConsentPrompt();
  if (isExitIntentPrompt) {
    return /*#__PURE__*/_jsx(ConsentModal, {
      headerMessage: exitIntentHeaderMessage,
      message: exitIntentMessage,
      onDeclineClick: handleDeclineCookies,
      onClick: handleConsentToCookies,
      useV2Style: isAIChatBot
    });
  }

  // ConsentPromptV2 fully self-styles the SPOTLIGHT variant (background,
  // border, padding), so the wrapper is skipped there to avoid double-boxing.
  // Gate on isSpotlight alone (not isAIChatBot): Spotlight is only used for
  // the AI chatbot experience, but isAIChatBot can still be resolving async
  // widget data, and falling through to the legacy ConsentPrompt in that
  // window renders an unstyled, inconsistent card.
  if (isSpotlight) {
    return /*#__PURE__*/_jsx(ConsentPromptV2, {
      variant: SPOTLIGHT,
      consentMessage: pageLoadMessage,
      onConsentAccept: handleConsentToCookies,
      showConsentButton: true,
      showDivider: false,
      isAIChatBot: isAIChatBot,
      accentColor: widgetColoring === null || widgetColoring === void 0 ? void 0 : widgetColoring.accentColor
    });
  }
  if (isAIChatBot) {
    return /*#__PURE__*/_jsx(ConsentPromptWrapper, {
      children: /*#__PURE__*/_jsx(ConsentPromptV2, {
        variant: CHAT_THREAD,
        consentMessage: pageLoadMessage,
        onConsentAccept: handleConsentToCookies,
        showConsentButton: true,
        showDivider: false,
        isAIChatBot: isAIChatBot,
        accentColor: widgetColoring === null || widgetColoring === void 0 ? void 0 : widgetColoring.accentColor
      })
    });
  }
  return /*#__PURE__*/_jsx(ConsentPrompt, {
    message: pageLoadMessage,
    onClick: handleConsentToCookies,
    onClose: () => {},
    showButton: true
  });
};
CookieConsentPrompt.displayName = 'CookieConsentPrompt';
export default CookieConsentPrompt;